@file:OptIn(ExperimentalSerializationApi::class)

package com.gsb.vyapar.bhagya.domain

import com.gsb.vyapar.bhagya.datasource.cache.SubCategoryEntity
import com.gsb.vyapar.bhagya.datasource.network.Dto
import com.gsb.vyapar.bhagya.domain.SubCategories.D.SubCategory
import io.ktor.util.decodeBase64Bytes
import io.ktor.util.encodeBase64
import korlibs.io.compression.compress
import korlibs.io.compression.deflate.GZIP
import korlibs.io.compression.uncompress
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromByteArray
import kotlinx.serialization.encodeToByteArray
import kotlinx.serialization.protobuf.ProtoBuf

@Serializable
data class SubCategories(
    val v: Int = 0,
    val d: D = D()
) {
    @Serializable
    data class D(
        val subCategories: List<SubCategory> = listOf()
    ) {
        @Serializable
        data class SubCategory(
            val id: Long = 0,
            val name: String = "",
            val categoryId: Long = 0,
            val deleted: Boolean = false,
        )
    }
}

fun Dto.toSubCategories(): SubCategories {
    return SubCategories(v = v, d = ProtoBuf.decodeFromByteArray<SubCategories.D>(d.decodeBase64Bytes().uncompress(GZIP)))
}

fun SubCategories.toDto(): Dto {
    return Dto(v = v, d = ProtoBuf.encodeToByteArray(d).compress(GZIP).encodeBase64())
}

fun String.decodeSubCategoriesString(): SubCategories {
    return try {
        if ("H4sIAAAAAAAAAAAAAAAAAAAA" == this) {
            return SubCategories()
        }
        ProtoBuf.decodeFromByteArray<SubCategories>(this.decodeBase64Bytes().uncompress(GZIP))
    } catch (e: Exception) {
        SubCategories()
    }
}

fun SubCategories.encodeSubCategoriesString(): String {
    return ProtoBuf.encodeToByteArray(this).compress(GZIP).encodeBase64()
}

fun SubCategoryEntity.toSubCategory(): SubCategory {
    return SubCategory(id, name, categoryId, deleted)
}

fun List<SubCategoryEntity>.toSubCategoryList(): List<SubCategory> {
    return map { it.toSubCategory() }
}

fun SubCategory.toSubCategoryEntity(): SubCategoryEntity {
    return SubCategoryEntity(id, name, categoryId, deleted)
}

fun List<SubCategory>.toSubCategoryEntityList(): List<SubCategoryEntity> {
    return map { it.toSubCategoryEntity() }
}

fun List<SubCategory>.toSubCategories(v: Int): SubCategories {
    return SubCategories(v, SubCategories.D(this))
}